import React, { useState, useEffect } from "react";
import Modal from "../modal-new";
import submit from "submit-form";

const INITIAL_STATE = {
  name: "",
  url: "",
  product: "",
  category: "",
  description: "",
};

const AddTutorialModal = ({
  tutorialCategories = [],
  selectedTutorial = null,
  product,
}) => {
  const [form, setForm] = useState(
    Object.assign({}, INITIAL_STATE, { product })
  );

  const handleForm = (field, value) => {
    setForm(Object.assign({}, form, { [field]: value }));
  };

  useEffect(() => {
    if (!selectedTutorial) return;
    const { _id, name, product, url, category, description } = selectedTutorial;
    setForm(
      Object.assign({}, form, {
        _id,
        name,
        product,
        url,
        category,
        description,
      })
    );
    return () => {
      setForm(Object.assign({}, INITIAL_STATE, { product }));
    };
  }, [selectedTutorial]);

  return (
    <div>
      <form
        action={`/actions/admin-panel/manage-category/video${
          selectedTutorial ? "/update" : ""
        }`}
        method="POST"
        id="add-tutorial"
      >
        <input
          type="hidden"
          name="video"
          value={selectedTutorial ? selectedTutorial._id : null}
        />
        <Modal
          className="add-tutorial-modal"
          width="1100px"
          onClose={() => {
            submit("/actions/refresh?", {
              method: "GET",
              body: {
                selectedTutorial: "",
                "modal[type]": "",
              },
            });
          }}
          title="MSB University"
        >
          <div className="body">
            <div className="right-panel">
              <div className="input-section">
                <label>Title</label>
                <input
                  name="name"
                  className="text-input"
                  placeholder="Enter Title"
                  value={form.name}
                  onChange={({ target: { value } }) =>
                    handleForm("name", value)
                  }
                />
              </div>
              <div className="input-section">
                <label>Link video</label>
                <input
                  name="url"
                  className="text-input"
                  placeholder="Paste the link for video"
                  value={form.url}
                  onChange={({ target: { value } }) => handleForm("url", value)}
                />
              </div>
              <input type="hidden" name="product" value={form.product} />

              <div className="input-section">
                <label>Category</label>
                <div
                  style={{
                    marginBottom: 16,
                  }}
                >
                  <select
                    name="category"
                    className="select-input rounded-select"
                    placeholder="Select a category"
                    value={form.category}
                    onChange={({ target: { value } }) =>
                      handleForm("category", value)
                    }
                  >
                    {selectedTutorial ? (
                      <option value="null">Uncategorized</option>
                    ) : null}
                    {(tutorialCategories || []).map((item, idx) => {
                      return (
                        <option key={idx} value={item.name}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="left-panel">
              <div
                className="input-section"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>Description</label>
                <textarea
                  name="description"
                  className="textarea-input"
                  placeholder="Enter Details here"
                  style={{
                    height: "100%",
                  }}
                  value={form.description}
                  onChange={({ target: { value } }) =>
                    handleForm("description", value)
                  }
                />
              </div>
            </div>
          </div>
          <footer>
            <button data-button-type="primary" type="submit">
              {selectedTutorial ? "Update" : "Create"}
            </button>
          </footer>
        </Modal>
      </form>
    </div>
  );
};

export default AddTutorialModal;
